export default "__VITE_ASSET__b802d12b__"